import { render } from "./VButton.vue?vue&type=template&id=790e9d70&scoped=true"
import script from "./VButton.vue?vue&type=script&lang=js"
export * from "./VButton.vue?vue&type=script&lang=js"

import "./VButton.vue?vue&type=style&index=0&id=790e9d70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790e9d70"],['__file',"src/components/VButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "790e9d70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('790e9d70', __exports__)) {
    api.reload('790e9d70', __exports__)
  }
  
  module.hot.accept("./VButton.vue?vue&type=template&id=790e9d70&scoped=true", () => {
    api.rerender('790e9d70', render)
  })

}


export default __exports__